export enum CategoryTypeEnum {
  CATEGORY_TREE = 'CategoryTree'
}
